import { render, staticRenderFns } from "./push_video_form.vue?vue&type=template&id=0dacf8e6"
import script from "./push_video_form.vue?vue&type=script&lang=js"
export * from "./push_video_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports